type PreviousPageInfo = {
  pageName: string;
  pageViewTime: number;
  pagePath: string;
};

type CompanyProperties = {
  companyId: string;
};

export class GlintsTrackingClient {
  private static _instance: GlintsTrackingClient | null = null;
  private _previousPageInfo: PreviousPageInfo | null = null;
  private companyProperties: CompanyProperties | null = null;
  private experimentationInfo: Record<string, unknown> | null = null;
  private flushListeners: Array<() => void> = [];

  public static getInstance(): GlintsTrackingClient {
    if (!this._instance) {
      this._instance = new GlintsTrackingClient();
    }
    return this._instance;
  }

  get getCompanyProperties() {
    return this.companyProperties;
  }

  setCompanyProperties(properties: CompanyProperties | null) {
    this.companyProperties = properties;
  }

  get getPreviousPageInfo() {
    return this._previousPageInfo;
  }

  setPreviousPageInfo(pageInfo: PreviousPageInfo | null) {
    this._previousPageInfo = pageInfo;
  }

  setExperimentationInfo(info: Record<string, unknown> | null) {
    this.experimentationInfo = info;
  }

  getExperimentationInfo() {
    return this.experimentationInfo;
  }

  resetCompanyProperties() {
    this.companyProperties = null;
    this.experimentationInfo = null;
  }

  private removeFlushListener(listener: () => void) {
    this.flushListeners = this.flushListeners.filter(l => l !== listener);
  }

  addFlushListener(listener: () => void) {
    this.flushListeners.push(listener);
    return () => this.removeFlushListener(listener);
  }

  flushEvents() {
    this.flushListeners.forEach(listener => listener());
  }
}
